<template>
    <VForm
        v-slot="{ form }"
        :on-submit-async="submit"
        @success="(value)=>this.$emit('success',value)">
        <DiscountCodeCreateAndUpdateFormItems :form="form" />
    </VForm>
</template>
<script>
import { rootActions } from '@/store/types'
import VForm from '@/components/VForm.vue'
import DiscountCodeCreateAndUpdateFormItems from '@/components/DiscountCodeCreateAndUpdateFormItems.vue'

export default {
    components: {
        VForm,
        DiscountCodeCreateAndUpdateFormItems,
    },
    methods: {
        async submit (values) {
            const res = await this.$store.dispatch(
                rootActions.ADD_DISCOUNT_CODE, { ...values },
            )
            return res
        },
    },
}
</script>
